import React from "react";
import { Component } from "react";
import { RequestHeaders } from "../../../../common/header-logo/request-header.component";

import InventoryUploadComponent from "../inventory-component/inventory-upload.component";
class InventoryUploadLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
                  
        }
    }
   
    render() {
            
        return(
            <div className="invoice-wrapper-container inventory-report-component" >
                <RequestHeaders headerTitle={'InventoryUpload'} />                
                <div className="request-table data-table fit-width details-container">
                    <InventoryUploadComponent />
                </div>    
            </div>
        )
    }
}

export default InventoryUploadLayout;